import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Breadcrumb, Tabs, Tooltip } from "antd";
import { Link } from "react-router-dom";
import UserRequestedConcierge from "./UserRequestedConcierge";
import WebsiteRequestedConcierge from "./WebsiteRequestedConcierge";

const RequestedConcierge = () => {
  const { t } = useTranslation();

  // const onChange = (key) => {
  //   console.log(key);
  // };
  const items = [
    {
      key: "1",
      label: <Trans> {t("requestedConcierge")}</Trans>,
      children: <UserRequestedConcierge />,
    },
    {
      key: "2",
      label: <Trans> {t("websiteRequestedConcierge")}</Trans>,
      children: <WebsiteRequestedConcierge />,
    },
  ];
  const colors = [
    '#D9E0E2'
  ];
  return (
    <>
      <div className="contentpart">
        <div className="right_content_col">
          <div className="content_wraper ">
            <div className="myorder">
              <div className="pagename">
              <Tooltip color={colors}   title={<span style={{ color: '#000000' }}> Monitor and manage your service requests with ease through our concierge service.</span>}>
                {t("requestedConcierge")}
                </Tooltip>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to="/dashboard">{t("home")}</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{t("requestedConcierge")}</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <br />

              <Tabs defaultActiveKey="1" items={items} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RequestedConcierge;
